import "./hierarchyGrid.less";

import { IComponentController, IComponentOptions } from "angular";

import { ICapsuleFolder, IKendoCapsuleData } from "../../typings/board/Models";
import { HIERARCHY_SERVICE, HierarchyService } from "../hierarchy-service/hierarchy.service";
import { KendoGridCapsuleFolder } from "../hierarchy-support/KendoGridCapsuleFolder";

export const HIERARCHY_COMPONENT: string = "hierarchyGridComponent";

class HierarchyGridCtrl implements IComponentController {

    private kendoData: IKendoCapsuleData[];
    private selectedFolder: ICapsuleFolder;
    private gridOptions: kendo.ui.GridOptions;
    private gridDataSource: kendo.data.DataSource;

    static $inject = [HIERARCHY_SERVICE, "$mdToast","$mdDialog"];

    constructor(private hierarchyService: HierarchyService,
        private $mdToast: ng.material.IToastService, private $mdDialog: ng.material.IDialogService) {
        var _self_: HierarchyGridCtrl = this;

        this.gridOptions = {
            filterable: {
                extra: false,
                operators: {
                    string: {
                        startswith: "Starts with",
                        eq: "Is equal to",
                        neq: "Is not equal to"
                    },
                    number: {
                        eq: "Is equal to",
                        neq: "Is not equal to",
                        gte: "Is greater or equal to",
                        gt: "Is greater than",
                        lte: "Is less than or equal to",
                        lt: "Is less than"
                    }
                }
            },
            columns: [
            { selectable: true, width: "25px"},
            {
                field: "icon",
                title:" ",
                width: "25px",
                filterable: false,
                sortable: false,
                template: (dataItem: IKendoCapsuleData) => {
                    if (dataItem.isFolder) {
                        return `<md-icon class="hierachyGridIcon" md-svg-src="admin:folder"></md-icon>`;
                    } else {
                        return `<md-icon class="hierachyGridIcon" md-svg-src="admin:file"></md-icon>`;
                    }
                }
            },
            {
                field: "fileFolderName",
                template: dataItem => `<span ng-non-bindable>${dataItem.fileFolderName}</span>`,
                title: "File/Folder name",
                width: "75px"
            },
            {
                field: "fileFolderSize",
                title: "Size (Kb)",
                width: "50px",
                attributes: { style: "text-align:right" }
                   
            },
            { field: "filefolderLastModifiedDate", title: "Last modified date", width: "100px", attributes:{ style:"text-align:right"}}
            ],
            resizable: true,
            pageable: true,
            sortable: true,
            scrollable: false,
            change: function(e : any):void {
                var selectedRows: any = this.select();
                var selectedDataItems : IKendoCapsuleData[] = [];
                for (var i : number = 0; i < selectedRows.length; i++) {
                    var dataItem : any = this.dataItem(selectedRows[i]);
                    selectedDataItems.push(dataItem);
                }
                _self_.hierarchyService.updateKendoSelectedData(selectedDataItems);
            }
        };

        this.initiazileDatagrid();

        this.hierarchyService.$getSelectedFolder()
        .subscribe((value)=> {
            if (value != null) {
                this.selectedFolder = value;
                this.updateKendoData();
            }
        });
    }

    private initiazileDatagrid():void {
        this.kendoData = [];
        this.gridDataSource = new kendo.data.DataSource({
            pageSize:20,
            data: this.kendoData,
            schema: {
                model: {
                    fields: {
                        fileFolderName: { type: "string" },
                        fileFolderSize: { type: "number" },
                        filefolderLastModifiedDate: { type: "string" },
                    }
                }
            }
    });
    }

    private updateKendoData(): void {
        var gridUpdated :boolean = false;
        this.initiazileDatagrid();

        if (this.selectedFolder.subFolders) {
            this.selectedFolder.subFolders.forEach(folder => {
                this.kendoData.push(new KendoGridCapsuleFolder(folder.name, "", folder.size, folder.modifiedDate, true));
            });
            gridUpdated = true;
        }
        if (this.selectedFolder.files) {
            this.selectedFolder.files.forEach(file => {
                this.kendoData.push(new KendoGridCapsuleFolder(file.name, file.extension, file.size, file.modifiedDate, false));
            });
            gridUpdated = true;
        }
        if (gridUpdated) {
            this.gridDataSource.fetch();
        }
    }
}

export const hierarchyGridComponent: IComponentOptions = {
    controller: HierarchyGridCtrl,
    template: require("./hierarchyGrid.html"),
    bindings: {},
};




// WEBPACK FOOTER //
// ./app/hierarchy-grid/hierarchyGrid.component.ts